var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconClients = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.484 22.547h9.844M11.297 5.672h9.844a1.406 1.406 0 0 1 1.406 1.406v9.844a1.406 1.406 0 0 1-1.406 1.406H5.67a1.406 1.406 0 0 1-1.405-1.406v-1.406h18.28M1.454 9.89h7.031m7.735 12.656h-5.625l.703-4.219h4.219zM2.859 1.453h4.22s1.405 0 1.405 1.406v8.438s0 1.406-1.406 1.406H2.86s-1.406 0-1.406-1.406V2.859s0-1.406 1.406-1.406"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M8.484 22.547h9.844M11.297 5.672h9.844a1.406 1.406 0 0 1 1.406 1.406v9.844a1.406 1.406 0 0 1-1.406 1.406H5.67a1.406 1.406 0 0 1-1.405-1.406v-1.406h18.28M1.454 9.89h7.031m7.735 12.656h-5.625l.703-4.219h4.219zM2.859 1.453h4.22s1.405 0 1.405 1.406v8.438s0 1.406-1.406 1.406H2.86s-1.406 0-1.406-1.406V2.859s0-1.406 1.406-1.406"
  }));
});
export default SvgIconClients;
export const raw = __webpack_public_path__ + "static/media/IconClients.d6b80c5878fd7e163996b2b656d09c88.svg";